import {
  withCompInfo,
  withStateRefsValues,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations/siteAssets';
import type { ResponsiveContainerProps } from '@wix/thunderbolt-components';
import type { IHamburgerMenuRootProps } from '../HamburgerMenuRoot.props';
import type { IHamburgerMenuRootDefinition } from '../documentManagement/HamburgerMenuRoot.definition';

export type IHamburgerMenuRootCarmiProps = {
  containerProps?: ResponsiveContainerProps;
  containerRootClassName?: string;
};

export const props = withCompInfo<
  IHamburgerMenuRootProps,
  IHamburgerMenuRootDefinition,
  IHamburgerMenuRootCarmiProps
>()(
  ['compData', 'hasResponsiveLayout', 'compMeshProps'],
  ({ compData, hasResponsiveLayout }, carmiData) => {
    return {
      ...compData,
      ...carmiData,
      hasResponsiveLayout,
      isMenuOpen: undefined,
      shouldFocus: true,
    };
  },
);

export const stateRefs = withStateRefsValues(['editorType']);

export default createComponentMapperModel({ props, stateRefs });
